import { selectBillingContact } from '@repo/api-adapters/selectors/customer.selectors';
import type { AssetDataType } from '@repo/types/asset';
import type { CustomerDetailsRaw } from '@repo/utils';

export const getCustomerType = (asset: AssetDataType) =>
    // 'Business' and 'PRIVATE' are the only options accepted by window.salja.customerProfile.searchCustomer API
    selectBillingContact(asset)?.isBusinessCustomer ? 'Business' : 'PRIVATE';

export const isRimsCustomer = (customer?: CustomerDetailsRaw) => {
    if (!customer) {
        return false;
    }

    return customer.accountType === 'INVOICE' && customer.source === 'RIMS';
};

export const isRegisteredCustomer = (customer?: CustomerDetailsRaw) => {
    if (!customer) {
        return false;
    }

    return customer.isRegistered ?? customer.customerClassification === 'REGISTERED';
};
